import { Link, useNavigate } from "react-router-dom";
import { useCreateClient } from "@/api/clients";
import { ClientForm } from "@/components/forms/ClientForm";
import { Card, CardContent } from "@/components/ui/card";
import { PageHeader } from "@/components/ui/page-header";

export function NewClientPage() {
  const navigate = useNavigate();
  const create = useCreateClient();

  return (
    <div className="flex max-w-3xl flex-col gap-6">
      <Link to="/clients" className="text-sm text-muted-foreground hover:text-foreground">
        ← Clients
      </Link>
      <PageHeader
        title="New client"
        description="Contacts and the rate card are added after the client is created."
      />
      <Card>
        <CardContent>
          <ClientForm
            mode="create"
            submitLabel="Create client"
            onSubmit={async (input) => {
              const client = await create.mutateAsync(input);
              navigate(`/clients/${client.id}`);
            }}
            onCancel={() => navigate("/clients")}
          />
        </CardContent>
      </Card>
    </div>
  );
}
